module.exports = __webpack_public_path__ + "img/22.cb23e81d.jpg";